<template lang="html">
  <section class="merge-list-view" v-if="de">
    <table
      class="slds-table slds-table_cell-buffer slds-no-row-hover slds-table_bordered slds-table_col-bordered"
      aria-label="Example table of Opportunities with vertical borders"
    >
      <thead>
        <tr class="slds-line-height_reset">
          <th
            v-for="(val, index) in columnLabels"
            :key="index"
            :id="index"
            class=""
            scope="col"
          >
            <div class="slds-truncate" :title="val">{{ val }}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="slds-hint-parent"
          v-for="(val_field_label, index_field_label) in fieldLabels"
          :key="index_field_label"
          :id="index_field_label"
        >
          <td class="row-label" :data-label="''">
            <div class="slds-truncate" :title="val_field_label.label">
              {{ val_field_label.label }}
            </div>
          </td>
          <td
            v-for="(val, index) in val_field_label.fieldList"
            :key="index"
            :id="index"
            :data-label="dataSources[index]"
            class=""
          >
            <div class="slds-truncate" :title="val.label">
              {{ val.label }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script lang="js">
  import { mapState } from "vuex";
  import utils from "@/utils";

  export default {
    name: "merge-list-view",
    props: {
      deId: String,
      appId: String
    },
    computed: {
      ...mapState({
        apps: "apps",
        messages: "messages"
      }),
      app() {
        return this.apps.find(app => app.uuid === this.appId);
      },
      de() {
        return this.app.dataElements[this.deId];
      },
      dataSources() {
        const dataElements = this.de.sources.map(sourceConfig => sourceConfig.dataSource);
        return dataElements.map(element => {
          if (this.app.dataElements[element]) {
            return this.app.dataElements[element].name
          } else {
            return this.getMessageText(this.messages.DATA_NOT_FOUND);
          }
        });
      },
      columnLabels() {
        return ["", ...this.dataSources];
      },
      fieldLabels() {
        return utils.setFieldLabels(this.de.sources, this.de.fieldOrder, this.app.dataElements);
      }
    }
  }
</script>

<style scoped lang="scss">
  .merge-list-view {
    .row-label {
      font-weight: 700;
      background-color: #fafaf9;
    }
  }
</style>
